import { radioAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { colours } from "@shared/ui.design-system";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(radioAnatomy.keys);

const dark = definePartsStyle({
  // define the part you're going to style
  control: {
    borderColor: colours.primary.medium,
    _checked: {
      bg: colours.primary.dark
    }
  }
});

export const Radio = defineMultiStyleConfig({ variants: { dark } });
